<template>
  <b-col
    id="sidebar"
    class="sidebar-color p-4 d-flex flex-column justify-content-between"
    :style="{ height: 100 }"
    :cols="mobile ? 12 : 3"
    data-cy="sidemenu-container"
  >
    <side-stepper
      :steps="steps"
      :actual="actualStep"
      v-if="!mobile"
      data-cy="sidemenu-stepper"
    ></side-stepper>
    <div 
      class="d-none d-md-block text-center"
      data-cy="sidemenu-logo-container"
    >
      <img 
        width="30%"
        src="@/assets/images/clinic-round.svg"
        data-cy="sidemenu-logo"
      />
    </div>
    <span class="text-secondary" data-cy="sidemenu-separator"></span>
    <div 
      class="d-flex align-items-center justify-content-center"
      v-if="mobile"
      data-cy="sidemenu-mobile-progress-container"
    >
      <vue-circle
        :progress="progress"
        :size="90"
        :reverse="false"
        :fill="fillColor"
        line-cap="round"
        empty-fill="rgba(255, 255, 255, 1)"
        :animation-start-value="0.0"
        :start-angle="4.7"
        insert-mode="append"
        :thickness="7"
        :show-percent="false"
        ref="circle"
        data-cy="sidemenu-mobile-progress"
      >
        <h5 class="text-white" data-cy="sidemenu-mobile-progress-label">
          {{ actualStep }} de {{ Object.keys(steps).length }}
        </h5>
      </vue-circle>
      <div
        class="d-flex flex-column font-weight-bold ml-3 text-white"
        style="width:200px;"
        data-cy="sidemenu-mobile-step-info"
      >
        <h4 
          v-if="Object.values(steps)[actualStep - 1]"
          data-cy="sidemenu-mobile-step-desc"
        >
          {{ Object.values(steps)[actualStep - 1].description }}
        </h4>
        <h6 
          v-if="Object.values(steps)[actualStep]"
          data-cy="sidemenu-mobile-step-next"
        >
          Próximo: {{ Object.values(steps)[actualStep].description }}
        </h6>
      </div>
    </div>
  </b-col>
</template>

<script>
import SideStepper from "@/components/sidestepper.vue";
import VueCircle from "vue2-circle-progress/src/index.vue";

export default {
  name: "side-menu",
  components: {
    SideStepper,
    VueCircle
  },
  data() {
    return {
      fillColor: { color: "#123" }
    };
  },
  watch: {
    $route() {
      if (this.$refs.circle) {
        this.$refs.circle.updateFill(this.fill.color);
        this.$refs.circle.updateProgress(this.progress);
      }
    }
  },
  computed: {
    progress() {
      return Math.round(
        (this.actualStep / Object.keys(this.steps).length) * 100
      );
    },
    steps() {
      return this.$store.getters.get_steps;
    },
    actualStep() {
      return this.$store.getters.get_actualStep;
    },
    mobile() {
      return this.$store.getters.width < 768;
    },
    selected() {
      return this.$store.getters.get_selected;
    }
  }
};
</script>

<style></style>
